import React from 'react';
export function Footer() {
  return <footer className="py-12 px-4 md:px-8 bg-[#1A1A1A] text-white" data-id="element-114">
      <div className="max-w-6xl mx-auto text-center" data-id="element-115">
        <h3 className="text-2xl font-bold mb-2" data-id="element-116">Recuerdos Eternos</h3>
        <p className="text-gray-400 mb-6" data-id="element-117">
          Hecho con ❤️ para familias que quieren guardar lo más valioso
        </p>
        <div className="border-t border-gray-700 pt-6" data-id="element-118">
          <p className="text-sm text-gray-400 mb-2" data-id="element-119">
            © 2026 · Todos los derechos reservados
          </p>
          <p className="text-sm text-gray-400" data-id="element-120">
            🔒 Sitio seguro · Pagos 100% protegidos
          </p>
        </div>
      </div>
    </footer>;
}